import { updateQuoteRetrievalError } from '../../slices/quote';
import { AppDispatch } from '../../store';
import { Cover } from '../../types/cover';
import { Risk } from '../../types/policy';
import { RiskClassCode } from '../../types/risk';
import { RiskNotFoundError } from './errors';
import { getRiskByClassCode } from './getRiskByClassCode';

export const getCovers = ({ risks, dispatch }: { risks: Risk[]; dispatch: AppDispatch }) => {
  const liabilityRisk = getRiskByClassCode(risks, RiskClassCode.Liability);
  if (!liabilityRisk) {
    dispatch(updateQuoteRetrievalError(true));
    throw new RiskNotFoundError(RiskClassCode.Liability);
  }
  const portableItemsRisk = getRiskByClassCode(risks, RiskClassCode.PortableItems);
  const buildingAndContentsRisk = getRiskByClassCode(risks, RiskClassCode.BuildingAndContents);
  const theftMoneyGlassRisk = getRiskByClassCode(risks, RiskClassCode.TheftMoneyGlass);
  const taxAuditRisk = getRiskByClassCode(risks, RiskClassCode.TaxAudit);
  const liabilityDetails = liabilityRisk.riskDetail.riskBPKLiability;
  const riskBPKEmployeeDishonestyTaxAuditTransitDetail =
    taxAuditRisk?.riskDetail?.riskBPKEmployeeDishonestyTaxAuditTransit;
  const portableItemsRiskDetails =
    portableItemsRisk?.riskDetail?.riskBPKGeneralPropertyMachineryBreakdown;
  const buildingAndContentsRiskDetails =
    buildingAndContentsRisk?.riskDetail?.riskBPKFireBusinessInterruption;
  const theftMoneyGlassRiskDetails = theftMoneyGlassRisk?.riskDetail?.riskBPKTheftMoneyGlass;

  const portableItemsDetails = portableItemsRiskDetails?.generalProperty;
  const {
    theft: theftDetails,
    money: moneyDetails,
    glass: glassDetails,
  } = theftMoneyGlassRiskDetails ?? {};

  const { fire: buildingAndContentsDetails, businessInterruption: businessInterruptionDetails } =
    buildingAndContentsRiskDetails ?? {};

  let machineryBreakdown = portableItemsRiskDetails?.machineryBreakdown;
  // machineryBreakdown might be set even if not selected. Check if any values is set to determine if machineryBreakdown
  // has been selected
  if (
    machineryBreakdown &&
    !machineryBreakdown.machineryBreakDownExcess &&
    !machineryBreakdown.machineryBlanketSI &&
    !machineryBreakdown.machineryBlanketNumberOfItems &&
    !machineryBreakdown.deteriorationOfStockSI
  ) {
    machineryBreakdown = undefined;
  }

  const liabilityExists = !!liabilityDetails.liabilityExcess;
  const buildingAndContentsExists = !!(
    buildingAndContentsDetails?.buildingExcess || buildingAndContentsDetails?.contentsExcess
  );
  const businessInterruptionExists = !!businessInterruptionDetails?.grossIncomeExcess;
  const portableItemsExists = !!portableItemsDetails?.generalPropertyExcess;
  const theftExists = !!theftDetails?.theftExcess;
  const moneyExists = !!moneyDetails?.moneyExcess;
  const glassExists = !!glassDetails?.glassExcess;
  const machineryBreakdownExists = !!machineryBreakdown;
  const taxAuditExists = !!riskBPKEmployeeDishonestyTaxAuditTransitDetail?.taxAudit;
  return [
    ...(liabilityExists ? [Cover.Liability] : []),
    ...(buildingAndContentsExists ? [Cover.BuildingAndContents] : []),
    ...(businessInterruptionExists ? [Cover.BusinessInterruption] : []),
    ...(portableItemsExists ? [Cover.PortableItems] : []),
    ...(theftExists ? [Cover.Theft] : []),
    ...(moneyExists ? [Cover.Money] : []),
    ...(glassExists ? [Cover.Glass] : []),
    ...(machineryBreakdownExists ? [Cover.Breakdown] : []),
    ...(taxAuditExists ? [Cover.TaxAudit] : []),
  ];
};
